/**
 * Christmas Campaign Asset Positions
 *
 * All positions are extracted from figma-export.json
 * Coordinates are relative to the frame (frame y=506 subtracted from absolute y)
 * Positions represent the TOP-LEFT corner of each element
 */

export const CANVAS = {
  width: 2048,
  height: 1364,
};

// Frame offset in Figma (the frame starts at y=506 in the Figma canvas)
const FRAME_Y_OFFSET = 506;

// Helper to convert absolute Figma coordinates to relative frame coordinates
const rel = (absX: number, absY: number) => ({
  x: absX,
  y: absY - FRAME_Y_OFFSET,
});

// Layer order from Figma (bottom to top):
// 1. Backgrounds
// 2. Tree
// 3. Gifts (in specific order for z-layering)
// 4. Fireplace
// 5. Socks
// 6. Decorations (cup, plates)

export const TREE = {
  ...rel(577, 505),
  width: 1025,
  height: 1080,
  zIndex: 10,
};

// Fireplace - position for the flames overlay
export const FIREPLACE = {
  ...rel(273, 954),
  width: 347,
  height: 286,
  zIndex: 30,
};

// Gifts - ordered by their layer position in Figma (bottom to top)
// This order determines which gifts appear "in front" of others
export const GIFTS = [
  // Bottom layer gifts (appear behind others)
  { id: 'Gift_Right_17', ...rel(1360, 1265), width: 159, height: 133, zIndex: 20 },
  { id: 'Gift_Right_16', ...rel(1304, 1317), width: 119, height: 122, zIndex: 21 },
  { id: 'Gift_Right_15', ...rel(1217, 1356), width: 153, height: 154, zIndex: 22 },
  { id: 'Gift_Left_14', ...rel(595, 1257), width: 159, height: 139, zIndex: 23 },
  { id: 'Gift_Left_13', ...rel(743, 1308), width: 139, height: 137, zIndex: 24 },
  { id: 'Gift_Center_12', ...rel(989, 1396), width: 122, height: 113, zIndex: 25 },
  { id: 'Gift_Center_11', ...rel(1097, 1383), width: 163, height: 155, zIndex: 26 },
  { id: 'Gift_Left_10', ...rel(821, 1355), width: 164, height: 166, zIndex: 27 },
  { id: 'Gift_Left_9', ...rel(618, 1346), width: 151, height: 135, zIndex: 28 },
  { id: 'Gift_Left_8', ...rel(703, 1423), width: 136, height: 113, zIndex: 29 },
  { id: 'Gift_Right_7', ...rel(1420, 1367), width: 124, height: 111, zIndex: 30 },
  { id: 'Gift_Right_6', ...rel(1336, 1424), width: 133, height: 109, zIndex: 31 },
  { id: 'Gift_Right_5', ...rel(1205, 1455), width: 141, height: 129, zIndex: 32 },
  { id: 'Gift_Center_4', ...rel(850, 1521), width: 58, height: 52, zIndex: 33 },
  { id: 'Gift_Center_3', ...rel(901, 1456), width: 117, height: 115, zIndex: 34 },
  { id: 'Gift_Center_2', ...rel(982, 1498), width: 147, height: 122, zIndex: 35 },
  // Top layer gift (appears in front)
  { id: 'Gift_Center_1', ...rel(1102, 1493), width: 132, height: 130, zIndex: 36 },
];

// Socks near fireplace
export const SOCKS = [
  { id: 'Left Sock', ...rel(205, 942), width: 90, height: 165, zIndex: 40 },
  { id: 'Right Sock', ...rel(285, 922), width: 76, height: 148, zIndex: 41 },
];

// Decorations
export const DECORATIONS = [
  { id: 'RightBottom_Cup', ...rel(1710, 1501), width: 112, height: 126, zIndex: 42 },
  { id: 'LeftBottomPlate', ...rel(144, 1692), width: 268, height: 177, zIndex: 43 },
];

// Convert pixel position to percentage of canvas
export const toPercent = (x: number, y: number) => ({
  leftPercent: (x / CANVAS.width) * 100,
  topPercent: (y / CANVAS.height) * 100,
});

// Convert pixel size to percentage of canvas
export const sizeToPercent = (width: number, height: number) => ({
  widthPercent: (width / CANVAS.width) * 100,
  heightPercent: (height / CANVAS.height) * 100,
});
